'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["children", "className", "contentClassName", "clerkID", "Initializing", "Processing", "Success", "Failure", "alignment", "ClientLibrary"];
/**
 * This is a wrapper for forms which handles the submit and sends it to Clerk,
 * a form handling service.
 *
 * Use this component as a replacement for the `<form>` tag.
 * Initial state is set with the `defaultValue` property on inputs. Radio
 * buttons are using `defaultChecked`.
 */

var BASE_URL = 'https://europe-west1-accodeing-saas.cloudfunctions.net/clerk_enqueue';
var LOADED = 0;
var INITIALIZING = 1;
var INITIALIZED = 2;
var PROCESSING = 3;
var SUCCESS = 4;
var FAILURE = 5;
var REPLACE = 'replace';
var ABOVE = 'above';
var BELOW = 'below';

var postData = function postData(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
};

var dataFromFormElements = function dataFromFormElements(elements) {
  var data = {};
  Array.from(elements).filter(function (element) {
    if (element.nodeName === 'INPUT') {
      if (element.type === 'radio' || element.type === 'checkbox') {
        return element.checked; // Only add checked ones
      } else if (element.type === 'hidden') {
        return true;
      } else if (element.type === 'submit') {
        return false;
      } else {
        // All other input types, like text and number
        return element.value !== ''; // Only add if field has value
      }
    } else if (element.nodeName === 'TEXTAREA') {
      if (element.id === 'comment') {
        return true;
      } else {
        return element.value !== ''; // Only add if field has value
      }
    } else if (element.nodeName === 'SELECT') {
      return element.value !== ''; // Only add if a value is selected
    }
  }).map(function (element) {
    if (element.type === 'checkbox') {
      if (data[element.name] === undefined) {
        data[element.name] = [];
      }

      data[element.name].push(element.value);
    } else {
      data[element.name] = element.value;
    }
  });
  return data;
};

var Clerk = function Clerk(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      clerkID = _ref.clerkID,
      Initializing = _ref.Initializing,
      Processing = _ref.Processing,
      Success = _ref.Success,
      Failure = _ref.Failure,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? REPLACE : _ref$alignment,
      _ref$ClientLibrary = _ref.ClientLibrary,
      ClientLibrary = _ref$ClientLibrary === void 0 ? require('./client-library.js') : _ref$ClientLibrary,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = React.useState(LOADED),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var form = React.useRef(null);
  var clientLibraryOnSubmit = React.useRef();

  var StatusComponent = function StatusComponent() {
    if (status === INITIALIZING) {
      return /*#__PURE__*/React__default["default"].createElement(Initializing, null);
    } else if (status === PROCESSING) {
      return /*#__PURE__*/React__default["default"].createElement(Processing, null);
    } else if (status === SUCCESS) {
      return /*#__PURE__*/React__default["default"].createElement(Success, null);
    } else {
      return /*#__PURE__*/React__default["default"].createElement(Failure, null);
    }
  };

  React.useEffect(function () {
    var alreadyInitialized = status >= INITIALIZED;
    var elementNotAvailable = !form.current;
    var exitEarly = alreadyInitialized || elementNotAvailable;

    if (exitEarly) {
      return;
    }

    if (status < INITIALIZING) {
      setStatus(INITIALIZING);
      return;
    }

    clientLibraryOnSubmit.current = new ClientLibrary(form.current, {
      autobind: false
    });
    setStatus(INITIALIZED);
  }, [status]);

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    setStatus(PROCESSING);
    clientLibraryOnSubmit.current();
    var data = dataFromFormElements(event.target.elements);
    postData("".concat(BASE_URL, "/").concat(clerkID), data).then(function (response) {
      return response.json();
    }).then(function (data) {
      setStatus(SUCCESS);
    })["catch"](function (error) {
      setStatus(FAILURE);
      console.error('Clerk error:', error);
    });
  };

  var showStatusComponent = [INITIALIZING, PROCESSING, SUCCESS, FAILURE].includes(status);
  var hideFormContent = showStatusComponent && alignment === REPLACE;
  var childrenStyle = hideFormContent ? {
    display: 'none'
  } : {};
  return /*#__PURE__*/React__default["default"].createElement("form", _extends({}, rest, {
    className: "clerk ".concat(className),
    ref: form,
    onSubmit: onSubmit,
    disabled: status !== INITIALIZED
  }), showStatusComponent && [ABOVE, REPLACE].includes(alignment) && /*#__PURE__*/React__default["default"].createElement(StatusComponent, null), /*#__PURE__*/React__default["default"].createElement("div", {
    style: childrenStyle,
    className: "clerk__children ".concat(contentClassName),
    "data-testid": "clerk-content"
  }, children), showStatusComponent && alignment === BELOW && /*#__PURE__*/React__default["default"].createElement(StatusComponent, null));
};

Clerk.propTypes = {
  alignment: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node.isRequired,
  className: PropTypes__default["default"].string,
  contentClassName: PropTypes__default["default"].string,
  Initializing: PropTypes__default["default"].elementType.isRequired,
  Processing: PropTypes__default["default"].elementType.isRequired,
  Success: PropTypes__default["default"].elementType.isRequired,
  Failure: PropTypes__default["default"].elementType.isRequired,
  ClientLibrary: PropTypes__default["default"].func,
  ariaLabelledBy: PropTypes__default["default"].string
};
exports.Clerk = Clerk;